const Footer = () => {
  return (
    <footer>
      <p>
        Made with{" "}
        <a href="https://fr.reactjs.org/" target="_blank" rel="noreferrer">
          React
        </a>{" "}
        at{" "}
        <a href="https://www.lereacteur.io/" target="_blank" rel="noreferrer">
          Le Reacteur
        </a>{" "}
        by{" "}
        <a
          href="https://fr.linkedin.com/in/valentin-gaborieau"
          target="blank"
          rel="noreferrer"
        >
          Valentin Gaborieau
        </a>
      </p>
    </footer>
  );
};

export default Footer;
